// import React, { useState, useEffect, useContext } from 'react';
// import axios from 'axios';
// import '../CSS/AllAffiliates.css'; // Keep the existing CSS file
// import { Context } from './Context';

// const AllAuthors = () => {
//   const { getAllAuthorsUrl } = useContext(Context); // Use a context or a constant for the authors URL
//   const [authors, setAuthors] = useState([]);
//   const [search, setSearch] = useState('');

//   useEffect(() => {
//     const fetchAuthors = async () => {
//       try {
//         const response = await axios.get("https://elexdondigitalacademy.com/api/getAuthors.php");

//         // Check if the response status is 'success'
//         if (response.data.status === 'success') {
//           setAuthors(response.data.data); // Update to handle author data
//         } else {
//           console.error('Failed to fetch authors:', response.data.message);
//         }
//       } catch (error) {
//         console.error('Error fetching authors:', error);
//       }
//     };

//     fetchAuthors();
//   }, [getAllAuthorsUrl]); // Update to fetch from the authors URL

//   const filteredAuthors = authors.filter(author =>
//     author.email.toLowerCase().includes(search.toLowerCase()) // Filter based on author name
//   );

//   return (
//     <div className="affiliates-wrapper" style={{ width: "100%" }}>
//       <h1 className="affiliates-heading">Authors</h1> {/* Update the heading */}
//       <input
//         type="text"
//         placeholder="Search by Author Email"
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//         className="affiliates-search-input" // Keep the same class for styling
//       />
//       <div className="affiliates-list">
//         {filteredAuthors.length > 0 ? (
//           filteredAuthors.map((author) => (
//             <div key={author.id} className="affiliate-card">
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Name:</span>
//                 <span className="affiliate-value">{author.full_name}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Email:</span>
//                 <span className="affiliate-value">{author.email}</span>
//               </div>
//               <div className="affiliate-detail">
//                 <span className="affiliate-label">Phone:</span>
//                 <span className="affiliate-value">{author.phone_number}</span> {/* Example to display author's books */}
//               </div>
          
//             </div>
//           ))
//         ) : (
//           <div>No authors found.</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AllAuthors;




// src/components/AllAuthors.jsx
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Context } from './Context';
import styled from 'styled-components';

const AllAuthors = () => {
  const { getAllAuthorsUrl } = useContext(Context);
  const [authors, setAuthors] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        // Fallback to direct URL if context variable is empty/undefined
        const url = getAllAuthorsUrl || "https://elexdondigitalacademy.com/api/getAuthors.php";
        const response = await axios.get(url);

        if (response.data.status === 'success') {
          setAuthors(response.data.data);
        } else {
          console.error('Failed to fetch authors:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching authors:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAuthors();
  }, [getAllAuthorsUrl]);

  const filteredAuthors = authors.filter(author =>
    author.email?.toLowerCase().includes(search.toLowerCase()) ||
    author.full_name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <PageContainer>
      <HeaderSection>
        <div>
          <h2>Authors Directory</h2>
          <p>View and manage all registered course authors and instructors.</p>
        </div>
        <SearchInput
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </HeaderSection>

      {loading ? (
        <LoadingState>Loading authors...</LoadingState>
      ) : (
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Author Name</th>
                <th>Email Address</th>
                <th>Phone Number</th>
              </tr>
            </thead>
            <tbody>
              {filteredAuthors.length > 0 ? (
                filteredAuthors.map((author) => (
                  <tr key={author.id}>
                    <td>
                      <UserCell>
                        <Avatar>
                          {author.full_name ? author.full_name.charAt(0).toUpperCase() : 'A'}
                        </Avatar>
                        <strong>{author.full_name || 'N/A'}</strong>
                      </UserCell>
                    </td>
                    <td>{author.email || 'N/A'}</td>
                    <td>
                      <PhoneBadge>{author.phone_number || 'Not provided'}</PhoneBadge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                    No authors found matching your search.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </TableWrapper>
      )}
    </PageContainer>
  );
};

export default AllAuthors;

// --- Styled Components ---
const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  font-family: inherit;
`;

const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  h2 {
    color: #0f172a;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 4px 0;
  }

  p {
    color: #64748b;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const SearchInput = styled.input`
  padding: 10px 16px;
  width: 280px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.95rem;
  outline: none;
  background-color: #ffffff;
  transition: all 0.2s ease;

  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const LoadingState = styled.div`
  text-align: center;
  padding: 48px;
  color: #64748b;
  font-size: 1rem;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  overflow-x: auto;
  border: 1px solid #e2e8f0;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 0.95rem;

  th, td {
    padding: 14px 20px;
    border-bottom: 1px solid #f1f5f9;
  }

  th {
    background-color: #f8fafc;
    color: #475569;
    font-weight: 600;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  tr:hover {
    background-color: #f8fafc;
  }
`;

const UserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1e293b;
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e0f2fe;
  color: #0369a1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
`;

const PhoneBadge = styled.span`
  display: inline-block;
  background: #f1f5f9;
  color: #475569;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.85ns;
  font-weight: 500;
  font-family: monospace;
`;